import { FC } from "react";

const SidebarFooter: FC = ({ children }) => {
  return <footer className="mt-[21px]">{children}</footer>;
};

export default SidebarFooter;
